// src/lib/csv.ts (v2.1)
// Codex C 指摘: CSV 出力だけは欲しい (PDF/PPT は将来)
// CsvButton (JSX 含む) は components/CsvButton.tsx に分離

/** rows[] (object array) を CSV 文字列に変換 */
export function rowsToCsv(rows: Record<string, unknown>[], columns?: string[]): string {
  if (rows.length === 0) return "";
  const cols = columns ?? Object.keys(rows[0]);
  const esc = (v: unknown): string => {
    if (v == null) return "";
    const s = typeof v === "object" ? JSON.stringify(v) : String(v);
    return /[,"\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const header = cols.map(esc).join(",");
  const body = rows.map((r) => cols.map((c) => esc(r[c])).join(",")).join("\n");
  return `${header}\n${body}`;
}

/** BLOB を生成して download (BOM 付きで Excel が UTF-8 で開けるように) */
export function downloadCsv(rows: Record<string, unknown>[], filename: string, columns?: string[]): void {
  const csv = rowsToCsv(rows, columns);
  const BOM = "﻿";
  const blob = new Blob([BOM + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
